import * as React from "react";
import * as styles from "./controls-infobox.css";

const ControlsInfoBox: React.SFC<{}> = (props) => {
    return (
        <div className={styles.info}>
            <i className={`fas fa-info-circle ${styles.infoIcon}`} />
            {props.children}
        </div>
    );
};

export default ControlsInfoBox;
